<template>

    <div class="layout__container">

        <div class="layout__width-90 layout__padding-clear">

        <span class="text__colour-teal layout__position-left layout__padding-10-4 layout__width-100 text__align-center">
            <h3 class="layout__position-center">Modify Product Codes</h3><h4 class="layout__position-center">(Enter the record details and click to Save Changes or Cancel)</h4>
        </span>

            <el-form :model="product" ref="product" :rules="rules" class="layout__position-left layout__width-100">

                <div class="component__forms-4">
                    <el-form-item prop="productRef" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Order Code<span class="text__colour-red">*</span>
                        </div>
                        <p v-if="this.product.productRef">{{this.product.productRef}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="priceCode" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Price Code</div>
                        <p v-if="this.product.priceCode">{{this.product.priceCode}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="name" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Name<span class="text__colour-red">*</span></div>
                        <el-input v-model="product.name" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>

                <div class="component__forms-4">
                    <el-form-item prop="status" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Status</div>
                        <el-select v-model="product.status" placeholder="Select Status" clearable="true">
                            <el-option
                                    v-for="status in ravensworth.activeStatusWithHold.options"
                                    :key="status.id"
                                    :label="status.text"
                                    :value="status.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="type" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Type</div>
                        <el-select v-model="product.type" placeholder="Select Types" clearable="true">
                            <el-option
                                    v-for="type in ravensworth.priceCodeType.options"
                                    :key="type.id"
                                    :label="type.text"
                                    :value="type.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="press" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Press</div>
                        <el-select v-model="product.press" placeholder="Select Press" clearable="true">
                            <el-option
                                    v-for="press in ravensworth.press.options"
                                    :key="press.id"
                                    :label="press.text"
                                    :value="press.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="isoSize" class="component__forms__fields">
                        <div class="component__forms__fields__labels">ISO Size</div>
                        <el-select v-model="product.isoSize" placeholder="Select ISO Size" clearable="true">
                            <el-option
                                    v-for="iso in ravensworth.isoSize.options"
                                    :key="iso.id"
                                    :label="iso.text"
                                    :value="iso.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </div>
                <div class="component__forms-4">
                    <el-form-item prop="style" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Style</div>
                        <p v-if="this.product.style">{{this.product.style}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="paperWeight" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Weight</div>
                        <p v-if="this.product.paperWeight">{{this.product.paperWeight}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="paperType" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Type</div>
                        <p v-if="this.product.paperType">{{this.product.paperType}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="finishing" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Finishing</div>
                        <p v-if="this.product.finishing">{{this.product.finishing}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                </div>
                <div class="component__forms-4 layout__position-left">
                    <el-form-item prop="finishingInstructions" class="component__forms__fields">
                        <span class="text_colour-909399 component__forms__fields__labels">Finishing Instructions</span>
                        <el-input type="textarea" :rows="4" v-model="product.finishingInstructions"
                                  class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="specialInstructions" class="component__forms__fields">
                        <span class="text_colour-909399 component__forms__fields__labels">Special Instructions</span>
                        <el-input type="textarea" :rows="4" v-model="product.specialInstructions"
                                  class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


            </el-form>

            <div class="layout__position-right layout__width-50">
                <el-button class="button-red button__base__admin layout__position-right">Delete</el-button>
                <el-button class="button-teal button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="">Cancel Changes
                </el-button>
                <el-button class="button-red button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="updateProduct('product')">Save Changes
                </el-button>
            </div>

        </div>
    </div>

</template>

<script>

    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "createCustomers",
        mixins: [axios, csvDownloadHelper, dataFormatter, backing],
        props: {
            product: {}
        },
        data() {
            return {
                types: [],
                statuses: [],
                presses: [],
                isos: [],
                finishings: [],
                rules: {
                    productRef: [{
                        required: true,
                        message: 'order code required',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: 'name required',
                        trigger: 'blur'
                    }],
                }
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            updateProduct(product) {
                this.$refs[product].validate((valid) => {
                    if (valid) {
                        console.log('done post')

                    } else {
                        return false;
                    }
                })
            }
        }
    };
</script>